import HeroSection from './components/HeroSection';
import UserTypeSection from './components/UserTypeSection';
import WorldNeedsSection from './components/WorldNeedsSection';
import Faq from './components/Faq';
import Testimonial from './components/Testimonial';
import StatsHighlights from './components/StatsHighlights';
import PodcastSection from './components/PodcastSection';
import Flowchart from './components/Flowchart';
import EntrepreunerSection from './components/EntrepreunerCallout';
import Footer from 'src/components/footer/footer';
import TopNavigation from './components/topNavigation/TopNavigation';
import Header from 'src/components/demo-day/header/Header';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useGetIdentity } from 'src/hooks';
import mixpanel from "mixpanel-browser";

const NewLandingPage= () => {
    mixpanel.init('2018d2d1e691b5826f68295e8ad1748a', {
    autocapture: true,
    record_sessions_percent: 100
    })
    
    const dispatch = useAppDispatch()
    const [change, setIsChange] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();
    const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
    const { getIdentities } = useGetIdentity();
    const { authenticatedId } = getIdentities();
  
    useEffect(() => {
      // Check if user is authenticated and redirect to /score
      if (authenticatedId) {
        navigate('/score');
        return;
      }

      window.scrollTo(0, 0)
      const handleScroll = () => {
        const scrollTop = window.scrollY;
        setIsChange(scrollTop > 100);
      };
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      }
    }, [authenticatedId, navigate])
  return (
    <div className="new-landing-page">
      {authenticatedId ? (<Header />) : <TopNavigation change={change} />}
      <HeroSection />
      <StatsHighlights />
      <UserTypeSection />
      <Flowchart/>
      <EntrepreunerSection/>
      <WorldNeedsSection />
      <Testimonial />
      <Faq />
      <PodcastSection />
      <Footer />
    </div>
  );
};

export default NewLandingPage;
